var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile_introduct_container flex_center"},[_c('img',{staticClass:"mobile_in_develop_img",attrs:{"src":require("../../../../assets/images/kaifazhong.png"),"alt":""}}),_c('p',{staticClass:"mobile_in_develop_text"},[_vm._v("正在开发中...")])])
}]

export { render, staticRenderFns }